import Navbar from "../../components/Navbar";
import Team from "../../components/Team";
import FAQ from "../../components/FAQ";
import GetStarted from "../../components/GetStarted";
import Footer from "../../components/Footer";

const About = () => {
    return (
        <>
            <Navbar/>
            <Team/>
            <FAQ/>
            <GetStarted/>
            <Footer/>
        </>
    )
}

export default About;